import Model from "~/models/_Model";

export default class ComparisonScoreComment extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/schoology";
  }

  // Set the resource route of the model
  resource() {
    return "comparisons/scores";
  }

  get sort_key() {
    return "";
    //return `${this.display_marking_periods}-${this.period}-${this.display_name}`;
  }

  get public_fields() {
    return [
      {
        name: "STUDENT_ID",
        label: "Student ID",
        format: (val) => val,
      },
      {
        name: "COMMENT_TEXT",
        label: "Comment",
        format: (val) => val,
      },
      {
        name: "PUBLISH",
        label: "Publish",
        format: (val) => val,
      },
      {
        name: "CHANGE_UID",
        label: "Change By",
        format: (val) => val,
      },
      {
        name: "ASMT_NUMBER",
        label: "Internal Asmt ID",
        format: (val) => val,
      },
    ];
  }

  getResultCount(resultType = null) {
    if (resultType) {
      return this.results[resultType].length;
    }
    let count = 0;
    Object.values(this.results).forEach(
      (subResult) => (count += subResult.length)
    );
    return count;
  }
}
